// This file is AI generated.
import { assertStatus, HttpStatusError } from 'lib/etl/assertStatus'

/** Default SWR fetcher: parses JSON and turns non-2xx responses into an HttpStatusError. */
export async function swrFetcher(url: string) {
  const response = await fetch(url).then(assertStatus.ok())

  return response.json()
}

/** 502–504 come from the proxy while the app restarts or is overloaded, not from our code. */
export function isGatewayError(error: unknown) {
  return (
    error instanceof HttpStatusError &&
    (error.status === 502 || error.status === 503 || error.status === 504)
  )
}
